<template>
  <div :class="['dropdown', { 'is-credit-card-field': creditCardField }, { 'is-active': showMenu }, { 'full-width-billing': fullWidth} ]" @mouseleave="mouseOut">
    <div class="dropdown-trigger">
      <button
        :class="['button button-dropdown', { 'is-fullwidth': isFullWidth }, btnMinWidth]"
        aria-haspopup="true"
        aria-controls="dropdown-menu"
        @click.prevent="toggleMenu">
        <span :class="[{ 'placeholder-style': applyPlaceholderStyling }, { 'has-text-weight-bold': boldSelectedText }]" v-text="placeHolderCopy" ref="dropdown"></span>
      </button>
      <i class="fas fa-angle-down" aria-hidden="true"></i>
    </div>
    <div class="dropdown-menu" role="menu">
      <div :class="['dropdown-content', { 'small-content-height' : smallContentHeight}, 'is-paddingless']">
        <a v-for="item in items" href="#" :key="item.value"
           class="dropdown-item"
           @click.prevent="onItemSelected(item, $event)" :ref="`${item.value}`"
           v-text="item.name">
        </a>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable indent,no-new,no-undef */
export default {
  name: 'DropDownBilling',
  props: {
    fullWidth: {
      type: Boolean,
      default: false
    },
    btnMinWidth: {
      type: String,
      default: 'button-width-150px'
    },
    placeHolder: {
      type: String,
      default: 'Placeholder...'
    },
    dropdownName: {
      type: String,
      default: 'group_name'
    },
    items: {
      type: Array,
      default: () => {
        return [{
          name: 'Example name',
          value: 'example_value'
        }]
      }
    },
    selectFirstItemOnMount: {
      type: Boolean,
      default: false
    },
    isFullWidth: {
      type: Boolean,
      default: false
    },
    noMarginLabels: {
      type: Boolean,
      default: false
    },
    boldSelectedText: {
      type: Boolean,
      default: false
    },
    creditCardField: {
      type: Boolean,
      default: false
    },
    smallContentHeight: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showMenuList: false,
      placeHolderText: '',
      triggeredOnMount: false
    }
  },
  created () {
    this.showDefaultDetails()
  },
  /**
   * Trigger click event for first item when component is mounted
   * @returns {void}
   */
  mounted () {
    if (this.selectFirstItemOnMount) {
      this.triggeredOnMount = true
      const refKey = this.items[0].value
      this.$refs[refKey][0].click()
      this.toggleMenu()
      this.triggeredOnMount = false
    }
  },
  computed: {
    showMenu () {
      return this.showMenuList
    },
    placeHolderCopy () {
      if (this.placeHolderText.length === 0) {
        return this.placeHolder
      }

      return this.placeHolderText
    },
    applyPlaceholderStyling () {
      return this.placeHolderText.length === 0
    }
  },
  methods: {
    showDefaultDetails () {
      if (this.$route.query.status) {
        let statusStr = this.$route.query.status
        let status = statusStr.substring(statusStr.indexOf('=') + 1)
        this.items.forEach((item) => {
          if (item.value === status) {
            this.$emit('changed', {
              name: item.name,
              value: item.value
            })
            this.placeHolderText = item.name
          }
        })
      }
    },
    resetFilters () {
      this.items.forEach((item) => {
        this.$refs[item.value][0].checked = false
      })
      this.$refs.dropdown.innerHTML = 'Select...'
    },
    onItemSelected (item, event) {
      this.$emit('changed', {
        name: item.name,
        value: item.value,
        triggeredOnMount: this.triggeredOnMount
      })
      this.placeHolderText = item.name
      this.toggleMenu()
    },
    toggleMenu () {
      this.showMenuList = !this.showMenuList
    },
    mouseOut () {
      this.showMenuList = false
    }
  }
}
</script>
<style scoped>
.tabs.is-toggle a {
  border-radius: 0;
  border: 0;
  padding: 10px 10px 11px 4px;
}

.tabs-open {
  padding: 10px 10px 24px 4px !important;
}

.tabs.is-boxed {
  background-color: #f5f5f5;
  border: 0 !important;
}

.search-filter-cont {
  background-color: #f5f5f5;
}

@media screen and (max-width: 767px) {
  .search-filter-cont {
    margin-top: 32px;
  }
}

.fa-filter {
  font-size: 1.2em;
}

label {
  color: #8a8c91;
  padding: .9em;
}

.dropdown {
  display: block;
  width: 100%;
}

.dropdown-trigger {
  text-align: left;
  height: 40px;
}

.button-dropdown {
  text-align: left;
  justify-content: left;
  min-width: 100%;
  color: #8A8C91;
  background-color: #fff !important;
  border-color: #dbdbdb !important;
  padding-left: 18px;
  font-size: 12px;
}

.placeholder-style {
  color: #c2c2c2 !important;
}

.fa-angle-down {
  font-size: 18px;
  font-weight: 900;
}

.button-dropdown > .icon {
  width: 24px;
  height: 24px;
}

.dropdown-menu {
  border-top: 3px solid #30AAE1;
  width: 100%;
  padding-top: 0 !important;
  border-bottom: 1px solid #e1dfdf;
}

.dropdown-placeholder {
  /*padding-left: calc(0.625em - 1px);*/
}

/*.fa-angle-down {*/
/*  font-size: 1.4rem;*/
/*}*/

.fa-angle-down:before {
  right: 0.7em;
}

.fa-angle-down:before {
  border: 1px solid #95979b;
  border-right: 0;
  border-top: 0;
  content: " ";
  display: block;
  height: 0.5em;
  pointer-events: none;
  position: absolute;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -webkit-transform-origin: center;
  transform-origin: center;
  width: 0.5em;
  margin-top: -0.375em;
  right: 1.125em;
  top: 50%;
  z-index: 400;
}

a.dropdown-item:hover {
  /*background-color: #30AAE1;*/
  /*color: #fff;*/
  background-color: rgba(103, 113, 122, 0.1) !important;
  color: #30aae1 !important;
}

.dropdown-item {
  padding: 10px !important;
  border: 1px solid transparent;
}

.dropdown-content {
  border-radius: 0;
  overflow-y: scroll;
  height: 120px!important;
}

.dropdown-content.small-content-height {
  height: 120px!important;
}

@media screen and (min-width: 768px) {
  .dropdown-trigger {
    width: 341px;
  }

  .button-dropdown {
    height: 39px ;
  }

  .is-credit-card-field, .is-credit-card-field > .dropdown-trigger {
    width: 104px;
  }

  .is-credit-card-field > .dropdown-trigger > .button-dropdown {
    height: 35px ;
  }

  .is-credit-card-field > .dropdown-menu {
    min-width: 0;
  }

  .dropdown-trigger {
    width: 100%;
    height: 35px!important;
    min-height: 35px!important;
  }

  .button-dropdown {
    height: 35px!important;
    min-height: 35px!important;
    padding-left: 15px;
  }
}

@media screen and (max-width: 767px) {
  .dropdown-trigger {
    width: 100%;
    height: 35px!important;
    min-height: 35px!important;
  }

  .button-dropdown {
    height: 35px!important;
    min-height: 35px!important;
    padding-left: 15px;
  }

  .dropdown-trigger {
    width: 341px;
  }

  .button-dropdown {
    height: 39px ;
  }

  .is-credit-card-field, .is-credit-card-field > .dropdown-trigger {
    width: 104px;
  }

  .is-credit-card-field > .dropdown-trigger > .button-dropdown {
    height: 35px ;
  }

  .is-credit-card-field > .dropdown-menu {
    min-width: 0;
  }

  .full-width-billing.is-credit-card-field, .full-width-billing.is-credit-card-field > .dropdown-trigger {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DropDownBilling.vue